<script lang="ts">
    export let button
    let status = false
</script>

<div class="accordion">
    <div class="accordion-item">
        <button class="accordion-header" on:click={() => status = !status}>{button}</button>
        <div class="accordion-body-wrapper" style="max-height: {status ? '300px' : '0px'};">
            <div class="accordion-body">
                <slot/>
            </div>
        </div>
    </div>
</div>

<style>
    .accordion {
        display: flex;
        flex-direction: column;
        margin: 10px 0;
    }

    .accordion-header {
        background: none;
        border: 0;
        padding: 0;
        border-bottom: 1px dashed #212529;
        line-height: normal;
        font-size: 14px;
        color: #212529;
        cursor: pointer;
    }

    .accordion-body-wrapper {
        overflow: hidden;
        transition: max-height .35s ease-out;
    }

    .accordion-body {
        padding: 10px;
    }
</style>
